import { render, staticRenderFns } from "./AromaVitalChart.vue?vue&type=template&id=0198f3a4&scoped=true"
import script from "./AromaVitalChart.vue?vue&type=script&lang=js"
export * from "./AromaVitalChart.vue?vue&type=script&lang=js"
import style0 from "./AromaVitalChart.vue?vue&type=style&index=0&id=0198f3a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198f3a4",
  null
  
)

export default component.exports